module.exports = __webpack_public_path__ + "static/media/Household-Goods.e755b189.jpg";